import { render, staticRenderFns } from "./UserMyPurchasesDedicatedNumbersUpdatePaymentMethodModal.vue?vue&type=template&id=568efee6&scoped=true&"
import script from "./UserMyPurchasesDedicatedNumbersUpdatePaymentMethodModal.vue?vue&type=script&lang=js&"
export * from "./UserMyPurchasesDedicatedNumbersUpdatePaymentMethodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568efee6",
  null
  
)

export default component.exports